import { Typography } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { useFormikContext } from 'formik'
import TipoNegociacaoLoteSelectInput from 'src/components/Formik/Forms/Inputs/TipoNegociacaoLoteSelectInput'
import TipoPedagioLoteSelectInput from 'src/components/Formik/Forms/Inputs/TipoPedagioLoteSelectInput'
import SwitchInput from '../../../components/SwitchInput'
import { isTipoContrato } from '../utils'

interface Props {
  isRestrictedEdit: boolean
}

export const NegociacaoComercial = ({ isRestrictedEdit }: Props) => {
  const { values } = useFormikContext<{
    tipoContratacao: string
  }>()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">Negociação Comercial</Typography>
      </Grid>
      {!isTipoContrato(values.tipoContratacao) && (
        <Grid item xs={12} sm={6}>
          <TipoNegociacaoLoteSelectInput
            name="tipoNegociacaoEmpresa"
            tipo="empresa"
            isRestrictedEdit={isRestrictedEdit}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <TipoNegociacaoLoteSelectInput
          name="tipoNegociacaoSubcontratado"
          tipo="subcontratado"
          isRestrictedEdit={isRestrictedEdit}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TipoPedagioLoteSelectInput
          name="tipoPedagio"
          label="Tipo de Pedágio"
          disabled={isRestrictedEdit}
          clearable
        />
      </Grid>
      {!isTipoContrato(values.tipoContratacao) && (
        <>
          <Grid item xs={6} sm={3}>
            <SwitchInput
              name="pedagio"
              label="Frete + Pedágio"
              disabled={isRestrictedEdit}
            />
          </Grid>

          <Grid item xs={6} sm={3}>
            <SwitchInput
              name="icms"
              label="Frete + Imposto"
              disabled={isRestrictedEdit}
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}
